import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Activity from "./Activity";
import { base_url } from "../../Constant";

const RecentActivity = () => {
  const [services, setServices] = useState([]);
  const [error, setError] = useState(null);

  // Function to parse raw iframe strings into structured objects
  const parseIframes = (iframeArray) => {
    return iframeArray
      .map((iframeString) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = iframeString.trim();
        const iframe = tempDiv.querySelector("iframe");

        if (!iframe) return null;

        return {
          src: iframe.getAttribute("src"),
          width: parseInt(iframe.getAttribute("width"), 10),
          height: parseInt(iframe.getAttribute("height"), 10),
        };
      })
      .filter((item) => item !== null);
  };

  useEffect(() => {
    AOS.init();

    // Fetch iframe data from API
    fetch(`${base_url}/recent-post`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        if (json && Array.isArray(json.data)) {
          const parsedIframes = parseIframes(json.data);
          setServices(parsedIframes);
        } else {
          throw new Error("Invalid response format");
        }
      })
      .catch((err) => {
        console.error("Error fetching recent posts:", err);
        setError("Unable to load recent activities at the moment.");
      });
  }, []);

  return (
    <Activity
      serviceHeader="Our Recent Prayas"
      description="Mallabhum Prayas has been actively engaged in various community service initiatives aimed at supporting those in need. Our recent efforts include providing in-person assistance to individuals requiring urgent medical help, including oxygen support for those facing respiratory challenges. Additionally, we have launched an ambulance service to ensure timely medical assistance for emergencies. Our food donation program has also been a success, providing nutritious meals to underprivileged families. These activities reflect our commitment to social welfare and community support, and we are grateful to all volunteers and donors who have contributed to making a positive impact."
      services={services}
      error={error}
    />
  );
};

export default RecentActivity;
